import styled from "styled-components"

export const AdminHeaderWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    padding: 0 22px;
   .admin_header_redirect_home{
        display: flex;
        align-items: center;
        i, a{
            color: #2f80ed;
            &:hover{
                color: #469ef4;
            }
        }
    }
    .admin_header_user{
        display: flex;
        align-items: center;
        div{
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #469ef4;

        }
        img{
            width: 100%;
            height: 100%;
            object-fit: contain;
            border-radius: 50%;
        }
        span{
            margin-left: 12px;
            font-weight: 500;
        }
    }
`
